<template>
    <LayoutDefault>
        <div id="home">
            <div class="lateral-container" :style="lateralContainerStyle" ref="lateralContainer" v-if="showLateralContainer">
                <HomeLateralTabs :activeTabName="activeTabName" @setTab="setTab" />
            </div>
            <div class="container" ref="container">
                <HomeCarousel/>
                <div class="content">
                    <section class="popular-models">
                        <HomeTabs :activeTabName="activeTabName" @setTab="setTab" v-if="!showLateralContainer" />
                        <HomeTabsContent :activeTabName="activeTabName" />
                    </section>
                </div>
                <HomeBannerFooter />
            </div>
        </div>
    </LayoutDefault>
</template>

<script>
import LayoutDefault from "../layouts/LayoutDefault2021";
import HomeBannerHeader from "../components/Banners/HomeBannerHeader";
import HomeBannerFooter from "../components/Banners/HomeBannerFooter";
import HomeTabs from "../components/Home/HomeTabs.vue";
import HomeLateralTabs from "../components/Home/HomeLateralTabs.vue";
import HomeTabsContent from "../components/Home/HomeTabsContent.vue";
import HomeCarousel from '../components/Banners/Carousel/HomeCarousel';
import ThemeManager from "../modules/ThemeManager/ThemeManager";

export default {
    components: {
        HomeBannerHeader,
        HomeBannerFooter,
        LayoutDefault,
        HomeTabs,
        HomeLateralTabs,
        HomeTabsContent,
        HomeCarousel,
    },
    props: {
        selectedTab: {
            type: String,
            default: null
        }
    },
    data(){
        const VALID_TABS = ['banner', 'celebrities', 'feeds', 'outstanding', 'webstars', 'categories'];
        const DEFAULT_TAB = this.loadDefaultTab();

        let activeTabName = DEFAULT_TAB;

        if (this.selectedTab && VALID_TABS.includes(this.selectedTab)) {
            activeTabName = this.selectedTab;
        }

        const ROUTER_TAB = {
            'home': DEFAULT_TAB,
            'celebrities': 'celebrities',
            'feeds.index': 'feeds',
            'outstandings': 'outstanding',
            'webstars.index': 'webstars',
            'categories': 'categories',
        };

        return {
            activeTabName,
            showLateralContainer: true,
            lateralContainerWidth: null,
            lateralContainerStyle: {},
            ROUTER_TAB
        }
    },
    methods: {
        setTab(tabName){
            let activeTabName = 'home';

            switch (tabName) {
                case 'celebrities':
                    activeTabName = 'celebrities';
                    break;
                case 'feeds':
                    activeTabName = 'feeds.index';
                    break;
                case 'outstanding':
                    activeTabName = 'outstandings';
                    break;
                case 'webstars':
                    activeTabName = 'webstars.index';
                    break;
                case 'categories':
                    activeTabName = 'categories';
                    break;
                default:
                    activeTabName = 'home';
                    break;
            }

            this.activeTabName = tabName;
            this.$router.push({ name: activeTabName });
        },
        loadDefaultTab() {
            // const NEW_DEFAULT_TAB = (ThemeManager.isDivasTheme()) ? 'banner' : 'celebrities';
            const NEW_DEFAULT_TAB = 'celebrities';

            if (
                this.activeTabName === this.DEFAULT_TAB 
                && this.DEFAULT_TAB !== NEW_DEFAULT_TAB
            ) {
                this.activeTabName = NEW_DEFAULT_TAB;
            }

            this.DEFAULT_TAB = NEW_DEFAULT_TAB;
            return NEW_DEFAULT_TAB;
        },
        loadIfNecessaryLateralContainerWidth() {
            if (this.lateralContainerWidth === null) {
                this.lateralContainerWidth = this.$refs.lateralContainer.clientWidth;
            }
        },
        loadLateralContainerStyle() {
            this.loadIfNecessaryLateralContainerWidth();

            if (this.showLateralContainer) {
                const MAX_WIDTH = 260;
                const containerMarginLeft = this.$refs.container.offsetLeft;
                const halfExtra = Math.ceil(Math.max(containerMarginLeft - this.lateralContainerWidth, 0) / 2);

                let appendRight = halfExtra;
                let appendLeft = Math.ceil(halfExtra / 2);

                if (this.lateralContainerWidth + appendRight > MAX_WIDTH) {
                    let diff = appendRight;
                    appendRight = MAX_WIDTH - this.lateralContainerWidth;
                    diff -= appendRight;

                    appendLeft += Math.ceil(diff / 2);
                }
                
                this.lateralContainerStyle = {
                    width: (this.lateralContainerWidth + appendRight) + 'px',
                    left: appendLeft + 'px',
                    display: 'block'
                }
            } else {
                this.lateralContainerStyle = {
                    width: '0px',
                    display: 'none'
                }
            }
        },
        onResize() {
            this.loadIfNecessaryLateralContainerWidth();

            let showLateralContainer = !!this.$refs.container;
    
            // Check if with of Lateral Container is lower than the left margin of the container
            if (showLateralContainer) {
                let containerMarginLeft = this.$refs.container.offsetLeft;
    
                showLateralContainer = parseInt(this.lateralContainerWidth) <= parseInt(containerMarginLeft);
            }
    
            this.showLateralContainer = showLateralContainer;
            this.loadLateralContainerStyle();
        }
    },
    watch: {
        $route (to, from) {
            console.log(to, from);
            if (this.ROUTER_TAB[to.name] !== this.activeTabName) {
                this.activeTabName = this.ROUTER_TAB[to.name];
            }
        },
        "$store.state.general.site_type": function(value) {
            this.loadDefaultTab();
        }

    },
    mounted() {
        this.$nextTick(() => {
            window.addEventListener('resize', this.onResize);
            this.onResize();
        });
    }
}
</script>

<style scoped lang="scss">
@import "./../styles/variables";

#home {
    position: relative;
}

.lateral-container {
    position: absolute;
}

.container {
    background-color: var(--pallete_dark_color);
    min-height: 500px;

    .error{
        text-align: center;
    }

    .content{
        // padding: 9px 0;
        padding: 0;
        margin-bottom: 15px;
        .popular-models {}
    }
}
</style>